export default (function () {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.document === 'undefined') {
    return;
  }
  return window.document;
});